// extracted by mini-css-extract-plugin
export var drawerContent = "_36-0";
export var valueBlock = "_36-1";
export var valueBlockFrom = "_36-2 _36-1";
export var valueBlockTo = "_36-3 _36-1";